import Icon from '../../components/Icon.vue'

Icon.register({"brands/xing-square":{"width":448,"height":512,"paths":[{"d":"M400 32H48C21.5 32 0 53.5 0 80V432C0 458.5 21.5 480 48 480H400C426.5 480 448 458.5 448 432V80C448 53.5 426.5 32 400 32zM140.4 320.2H93.8C88.3 320.2 85.1 314.9 87.8 309.9L137.1 223.2C137.2 223.2 137.2 223.1 137.1 223L105.7 169C102.7 163.4 105.9 158.9 111.7 158.9H158.3C163.5 158.9 167.8 161.8 171.2 167.6L203.1 222.9C201.8 225.2 185.1 254.6 153 311.1 149.5 317.3 145.3 320.2 140.4 320.2zM360.1 106.1L257.3 286.8V287L322.8 406C325.6 411.1 322.9 416.1 316.8 416.1H270.2C264.7 416.1 260.5 413.2 257.3 407.4L191.3 287.1C193.6 283 228.1 222.2 294.7 104.8 298 99 302.1 96.1 307.2 96.1H354.1C359.8 96 362.9 100.8 360.1 106.1z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/brands/xing-square.js
// module id = null
// module chunks = 